import axios from "axios";
import {getCookie, removeCookie, TOKEN_KEY} from "../cookie/CookieProvider";

const api = axios.create({
  baseURL: process.env.REACT_APP_DATA_MANAGER_ENDPOINT,
  timeout: 10000,
});

api.interceptors.request.use(
  (config) => {
    config.headers.Authorization = `Bearer ${getCookie(TOKEN_KEY)}`
    return config;
  },
  (error) => {
    console.log(error)
    return Promise.reject(error);
  }
)

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const statusCode = error.response?.status;
    if (statusCode === 401) {
      alert("세션 정보가 사라졌습니다. 다시 로그인해주세요.")
      removeCookie(TOKEN_KEY)
      window.location.href = "/auth/login"
    }
    return Promise.reject(error);
  }
);

export default api;